const QUINN_FENCE_RE = /```quinn:(?:kpi|chart|table)\r?\n[\s\S]*?```/g;
const QUINN_DOCUMENT_LINK_RE = /\[([^\]\n]+)\]\(doc:[^)\s]*\)/g;

export function plainTextForQuinnCopy(content: string): string {
    return content
        .replace(QUINN_FENCE_RE, "")
        .replace(QUINN_DOCUMENT_LINK_RE, "$1")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
}

export async function copyTextToClipboard(text: string): Promise<boolean> {
    if (typeof navigator === "undefined" || !navigator.clipboard?.writeText) {
        return false;
    }

    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        return false;
    }
}
